import { useCallback, useEffect, useState } from 'react';
import { History } from 'history';
import { SortParams } from '../components/search/admin-dashboard-tables/interfaces';
import fetchSearchParams from './fetchSearchParams';

const useLocationSortOnLoad = () => {
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    setHasLoaded(true);
  }, []);

  const syncCoordinatesToUrl = useCallback((history: History) => {
    if (hasLoaded) {
      return;
    }

    const {
      lat,
      lng,
    }: SortParams = fetchSearchParams();

    if (!lat && !lng) {
      const localLat = localStorage.getItem('latitude');
      const localLng = localStorage.getItem('longitude');
      if (localLat && localLng) {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        params.set('lng', localLng);
        params.set('lat', localLat);
        history.push(`${url.pathname}?${params.toString()}`);
      }
    }
  }, [hasLoaded]);

  return {
    syncCoordinatesToUrl,
  };
};

export default useLocationSortOnLoad;
